import React from 'react';
import styles from './byancasilvaa_.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import SiteIcon from '../../icons/siteIcon.tsx';

const Byancasilvaa_: React.FC = () => {

    return (
        <div className={styles.byancasilvaa_}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.cardOverlay}>
                        <h1 className="mb-0">Bianca da Silva</h1>
                        <p>ESTRATEGISTA DIGITAL</p>
                        <div className={styles.links}>
                            <LinkPersonalizado7
                                href="https://www.instagram.com/linksvibe_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                title="INSTAGRAM"
                                icon={<div style={{
                                    width: "max-content",
                                    paddingBottom: "4px",
                                    borderRadius: "100%",
                                }}><InstagramIcon height="32" color="#ffffff" /></div>}
                                colorText="#ffffff"
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517992613840?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                                title="WHATSAPP"
                                icon={<WhatsappIcon height="40" color="#ffffff" />}
                                colorText="#ffffff"
                            />
                            <LinkPersonalizado7
                                href="https://www.linksvibe.com.br"
                                title="SITE"
                                icon={<div style={{
                                    width: "max-content",
                                    paddingBottom: "4px",
                                    borderRadius: "100%",
                                }}><SiteIcon height="32" color="#ffffff" /></div>}
                                colorText="#ffffff"
                            />
                            <LinkPersonalizado7
                                href="/byancasilvaa_/servicos"
                                linkInterno={true}
                                title="SERVIÇOS"
                                icon={<CatalogIcon height="40" color="#ffffff" />}
                                colorText="#ffffff"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Byancasilvaa_;
